export default {
    computed: {
        isBonded() {
            return this.$store.getters.isBonded(this.promotion.type)
        },
        showItemInput() {
            return this.promotion.type === 'Promo::Bonded'
        }
    },
    methods: {
        isSetTrigger(set) {
            return set.type === 'ProductSet::Trigger'
        }
    }
}
